module.exports = __webpack_public_path__ + "static/16-41699069dc159bd5b811590f62213d17.jpg";